import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConditionalAccessPolicy } from '@microsoft/microsoft-graph-types-beta';
import { SessionControlsControllerValues } from '../../cap-generic-form';
import {
    CapSessionControlDialogComponent,
    CapSessionControlDialogData,
} from './cap-session-control-dialog/cap-session-control-dialog.component';

const cloudAppSecurity = {
    monitorOnly: 'Monitor only (Preview)',
    blockDownloads: 'Block downloads (Preview)',
    mcasConfigured: 'Use custom policy...',
};

const continuousAccessEvaluation = {
    strictLocation: 'Strictly enforce location policies (Preview)',
    disabled: 'Disable',
};

@Component({
    selector: 'cap-session-control',
    templateUrl: './cap-session-control.component.html',
    styleUrls: ['./cap-session-control.component.scss', '../../../../../styles/baseline-style.scss'],
})
export class CapSessionControlComponent {
    @HostBinding('style.display') display = 'contents';

    @Input() policy: ConditionalAccessPolicy;
    @Input() readOnly: boolean;
    @Input() form: FormGroup;
    @Input() errorsString: string = '';
    cloudAppSecurity = cloudAppSecurity;
    continuousAccessEvaluation = continuousAccessEvaluation;
    configureSession: boolean = true;

    constructor(private dialog: MatDialog) {}

    openSessionPopup() {
        const data: CapSessionControlDialogData = {
            session: this.sessionControllerValue,
        };

        const dialogRef = this.dialog.open(CapSessionControlDialogComponent, {
            data,
            position: {
                top: '0',
                right: '0',
            },
            minWidth: '500px',
            width: '30%',
            height: '100%',
            hasBackdrop: true,
        });

        dialogRef.afterClosed().subscribe((res: SessionControlsControllerValues) => {
            if (res) {
                this.disableResilienceDefaultsController.setValue(res.disableResilienceDefaults);
                // sigin in frequently
                this.signInFrequencyController.get('isEnabled').setValue(res.signInFrequency.isEnabled);
                this.signInFrequencyController.get('type').setValue(res.signInFrequency.type);
                this.signInFrequencyController.get('value').setValue(res.signInFrequency.value);
                this.signInFrequencyController.get('frequencyInterval').setValue(res.signInFrequency.frequencyInterval);
                this.signInFrequencyController
                    .get('authenticationType')
                    .setValue(res.signInFrequency.authenticationType);

                this.cloudAppSecurityController.setValue(res.cloudAppSecurity);
                this.persistentBrowserController.setValue(res.persistentBrowser);
                // continuousAccessEvaluation
                this.continuousAccessEvaluationController.get('mode').setValue(res.continuousAccessEvaluation.mode);
            }
        });
    }

    get sessionControllerValue(): SessionControlsControllerValues {
        return this.sessionController.value;
    }

    get sessionController(): FormGroup {
        return this.form.get('sessionControls') as FormGroup;
    }

    get disableResilienceDefaultsController(): FormControl {
        return this.sessionController.get('disableResilienceDefaults') as FormControl;
    }

    get signInFrequencyController(): FormGroup {
        return this.sessionController.get('signInFrequency') as FormGroup;
    }

    get continuousAccessEvaluationController(): FormGroup {
        return this.sessionController.get('continuousAccessEvaluation') as FormGroup;
    }

    get persistentBrowserController(): FormControl {
        return this.sessionController.get('persistentBrowser') as FormControl;
    }

    get cloudAppSecurityController(): FormGroup {
        return this.sessionController.get('cloudAppSecurity') as FormGroup;
    }
}
